

const date=new Date();
// 默认配置  default是默认配置标记
function addDate(date, days) {
    if (days == undefined || days == '') {
        days = 1;
    }
    var date = new Date(date);
    let hour=date.getHours();
    let min=date.getMinutes();
    let sec=date.getSeconds();
    date.setDate(date.getDate() + days);
    var month = date.getMonth() + 1;
    var day = date.getDate(); 
    return date.getFullYear() + '-' + getFormatDate(month) + '-' + getFormatDate(day) + ' '+(hour) + ':' + (min)+":"+(sec);
} //月份，在原有的日期基础上，增加 months 月份，默认增加1月 
function addMonth(date, months) {
    if (months == undefined || months == '') months = 1; var date = new Date(date); date.setMonth(date.getMonth() + months); var month = date.getMonth() + 1; var day = date.getDate(); 
    return date.getFullYear() + '-' + getFormatDate(month) + '-' + getFormatDate(day);
} // 日期月份/天的显示，如果是1位数，则在前面加上'0' 
function getFormatDate(arg) { if (arg == undefined || arg == '') { return ''; } var re = arg + ''; if (re.length < 2) { re = '0' + re; } return re; }

export default {
    "ex": {
        // 统计
        "method": 0,
        "startTime": addMonth(date, -7),
        "endTime": addMonth(date, -1),
        // 月
        "way": 1,
        "default": true,
    },
    "alarm": {
        // 统计
        "method": 0,
        "startTime": addMonth(date, -7),
        "endTime": addMonth(date, -1),
        // 年
        "way": 1,
        "default": true,
    },
    "normalAbnormal": {
        // 环比
        "method": 3,
        "startTime": addDate(date,-1),
        "endTime": vm.$timetransition(date.getTime()),
        // 年
        "way": 0,
        "default": true,
    }
}